import styled from 'styled-components';

export const AuthenticationExampleContainer = styled.div`
  margin: 20px;
  padding: 20px;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 8px;
`;
